import { queryOptions } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import type { User } from "@/schemas/models/user";

export const userKeys = {
  all: () => ["users"] as const,
  lists: () => [...userKeys.all(), "list"] as const,
  details: () => [...userKeys.all(), "detail"] as const,
};

export const userQueries = {
  me: () =>
    queryOptions({
      queryKey: [...userKeys.all(), "me"] as const,
      queryFn: () => apiFetch<User>("/api/me"),
      staleTime: Infinity,
      gcTime: Infinity,
    }),
  list: () =>
    queryOptions({
      queryKey: userKeys.lists(),
      queryFn: () => apiFetch<User[]>("/api/users"),
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: [...userKeys.details(), id] as const,
      queryFn: () => apiFetch<User>(`/api/users/${id}`),
      staleTime: 5 * 60 * 1000,
    }),
};
